<template>
    <div v-if="comprometimento">
        <b-row>
            <b-col sm="8">
                <h5 class="heading-1 mb-4">
                    <span>Comprometimento</span>
                </h5>
            </b-col>
            <b-col sm="4">
                <b-button
                    class="float-right"
                    variant="warning"
                    @click="voltarComprometimentos()"
                    ><i class="fa fa-history"></i> Voltar aos
                    comprometimentos</b-button
                >
            </b-col>
        </b-row>
        <b-alert variant="warning" show v-if="!comprometimento.saldoNaturezaOk"
            ><i class="fa fa-exclamation-triangle fa-lg"></i
            ><strong>
                O saldo da natureza de despesa do contrato é menor que o valor
                do comprometimento</strong
            ></b-alert
        >
        <b-alert show>
            <b-row>
                <b-col>
                    Id:
                    <strong>{{ comprometimento.chaveOrigem }}</strong
                    ><br />
                    Histórico:
                    <strong>{{ comprometimento.vcHistorico }}</strong
                    ><br />
                    Data Emissão :
                    <strong>{{
                        $moment(comprometimento.dtEmissao).format('DD/MM/YYYY')
                    }}</strong
                    ><br />
                    Data Movimento:
                    <strong>{{
                        $moment(comprometimento.dtEmissao).format('DD/MM/YYYY')
                    }}</strong
                    ><br />
                    Valor:
                    <strong>{{
                        comprometimento.nuValorComprometimento | currency
                    }}</strong
                    ><br />
                    Id RM: <strong>{{ comprometimento.idRm }}</strong
                    ><br />
                    Status:
                    <app-status
                        :status="comprometimento.statusDescr"
                    ></app-status>
                </b-col>
            </b-row>
        </b-alert>

        <b-row>
            <b-col sm="12">
                <h5 class="heading-1 mb-4">
                    <span>Rateios</span>
                </h5>
            </b-col>
        </b-row>
        <rateios-tabela
            :rateios="comprometimento.rateios"
            :valorASerRateado="valorASerRateado"
            :valorDisponivel="valorDisponivel"
            :operacao="operacao"
        >
            <template slot="botoes"> </template>
        </rateios-tabela>
    </div>
</template>

<script>
import RateiosTabela from './RateiosTabela'

export default {
    components: {
        RateiosTabela
    },

    props: {
        contrato: {
            type: Object,
            default: () => {}
        },

        comprometimento: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            operacao: 'D',
            rateios: []
        }
    },

    methods: {
        cancelar() {
            this.operacao = 'D'
            this.resetarRateios()
        },

        voltarComprometimentos() {
            this.operacao = 'D'
            this.$emit('atualizarComprometimento', null)
        }
    },

    computed: {
        valorASerRateado() {
            return this.comprometimento.nuValorComprometimento
        },

        valorRateado() {
            return Number.parseFloat(
                this.rateios
                    .map((item) => {
                        return item.nuValorRateio
                    })
                    .reduce((a, b) => a + b, 0)
                    .toFixed(2)
            )
        },

        valorDisponivel() {
            return Number.parseFloat(
                (this.valorASerRateado - this.valorRateado).toFixed(2)
            )
        },

        percentualRateado() {
            return (this.valorRateado / this.valorASerRateado) * 100
        },

        corTexto() {
            return this.percentualRateado < 100 ? 'danger' : 'primary'
        },

        corBox() {
            return this.percentualRateado < 100 ? 'danger' : 'primary'
        }
    }
}
</script>
